import React, { useEffect, useState } from "react";
import {
    Box,
    Tab,
    Tabs,
    Typography,
    makeStyles,
    Divider,
    useTheme,
    useMediaQuery,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import { getCurrencies } from "../../../actions/currencyActions";
import { getAllBudgetHeads } from "../../../actions/budgetHeadsActions";
import { getAllBudgetSubheads } from "../../../actions/budgetSubheadAction";
import { getAllBudgetItems } from "../../../actions/budgetItemActions";
import { getCostCodes } from "../../../actions/costCodeAction";

import SetupCurrency from "./SetupCurrency";
import SetupBudgetHead from "./SetupBudgetHead";
import SetupBudgetSubhead from "./SetupSubheads";
import SetupBudgetCategories from "./SetupBudgetCategories";
import SetupCostcenter from "./SetupCostcenter";



const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
    },
    title: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold"
    },
    title2: {
        display: "block",
        fontSize: 14,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
    },
}));

const BudgetSetup = () => {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();
    const dispatch = useDispatch();
    const theme = useTheme();
    const [loading, setLoading] = useState(true);
    const matches = useMediaQuery(theme.breakpoints.down("sm"));

    const { currencies } = useSelector((state) => state.currency);
    const { heads } = useSelector((state) => state.budgetHeads);
    const { subheads } = useSelector((state) => state.budgetSubheads);
    const { items } = useSelector((state) => state.budgetItems);
    const { costcodes } = useSelector((state) => state.costcode);

    useEffect(() => {
        dispatch(getAllBudgetHeads());
        dispatch(getAllBudgetSubheads());
        dispatch(getCurrencies());
        dispatch(getAllBudgetItems());
        dispatch(getCostCodes())
    }, [dispatch]);

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1500);
      }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Typography variant="overline" className={classes.title} gutterBottom>
                Budget Setup
            </Typography>

            <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant={matches ? "scrollable" : "fullWidth"}
                scrollButtons={matches ? "on" : "off"}
            >
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Currency
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(0)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Expense Head
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(1)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Expense SubHeads
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(2)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Budget Categories
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(3)}
                />
                <Tab
                    label={
                        <Typography className={classes.title2} gutterBottom>
                            Cost Center
                        </Typography>
                    }
                    fullWidth
                    {...a11yProps(4)}
                />
            </Tabs>
            
            <Divider />

            <TabPanel value={value} index={0}>
                <SetupCurrency {...{ loading, currencies }}  />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SetupBudgetHead {...{ loading, heads }} />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <SetupBudgetSubhead {...{ loading, subheads }} />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <SetupBudgetCategories {...{ loading, items }}/>
            </TabPanel>
            <TabPanel value={value} index={4}>
                <SetupCostcenter {...{ loading, costcodes }}/>
            </TabPanel>
        </div>
    );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default BudgetSetup;
